const SERIAL_STORAGE_KEY = "savedSerialPrinter";

export const isWebSerialSupported = () => {
  return typeof navigator !== "undefined" && !!navigator.serial;
};

let activeSerialPort = null;

export const requestSerialPrinter = async (options = {}) => {
  if (!isWebSerialSupported()) {
    throw new Error("Web Serial belum didukung. Gunakan Chrome terbaru melalui localhost atau HTTPS.");
  }

  const port = await navigator.serial.requestPort({ filters: [] });
  const baudRate = Number(options.baudRate || 9600);
  await openSerialPort(port, baudRate);

  const saved = {
    name: options.name || "Printer Thermal Serial",
    baudRate,
    usbVendorId: port.getInfo()?.usbVendorId || null,
    usbProductId: port.getInfo()?.usbProductId || null,
  };

  localStorage.setItem(SERIAL_STORAGE_KEY, JSON.stringify(saved));
  activeSerialPort = port;
  return saved;
};

const openSerialPort = async (port, baudRate = 9600) => {
  if (!port.readable && !port.writable) {
    await port.open({ baudRate });
  }
  activeSerialPort = port;
};

export const getSavedSerialPrinter = () => {
  const saved = localStorage.getItem(SERIAL_STORAGE_KEY);
  if (!saved) return null;
  try {
    return JSON.parse(saved);
  } catch {
    return null;
  }
};

export const sendRawSerialBytes = async (arrayBuffer) => {
  if (!isWebSerialSupported()) {
    throw new Error("Web Serial tidak didukung pada browser ini.");
  }

  let port = activeSerialPort;
  const saved = getSavedSerialPrinter();
  if (!saved) {
    throw new Error("Belum ada printer serial yang disambungkan.");
  }

  if (!port) {
    const ports = await navigator.serial.getPorts();
    port = ports.find((candidate) => {
      const info = candidate.getInfo();
      return saved.usbVendorId && saved.usbProductId
        ? info.usbVendorId === saved.usbVendorId && info.usbProductId === saved.usbProductId
        : true;
    });
  }

  if (!port) {
    throw new Error("Port COM tersimpan tidak ditemukan. Sambungkan ulang lalu pilih port serial.");
  }

  await openSerialPort(port, Number(saved.baudRate || 9600));
  if (!port.writable) {
    throw new Error("Port serial tidak dapat ditulis.");
  }

  const writer = port.writable.getWriter();
  try {
    const data = new Uint8Array(arrayBuffer);
    const chunkSize = 512;
    for (let index = 0; index < data.length; index += chunkSize) {
      await writer.write(data.slice(index, index + chunkSize));
    }
  } finally {
    writer.releaseLock();
  }

  return { method: "serial", success: true };
};

export const disconnectSerialPrinter = async () => {
  if (activeSerialPort) {
    try {
      await activeSerialPort.close();
    } catch {
      // Port mungkin sudah ditutup oleh browser atau perangkat.
    }
    activeSerialPort = null;
  }
  localStorage.removeItem(SERIAL_STORAGE_KEY);
};
